export function hasClass (dom, className) {
    return dom.className.indexOf(className) > -1;
}
